import {
  Autocomplete,
  Avatar,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import moment from "moment";
import { useMutation } from "react-query";
import {
  downloadClaims,
  getallStatus,
  UpdateClaimStatus,
} from "../../services";
import usePopup from "../../../hooks/usePopup";
import { useContext, useEffect, useState } from "react";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { clinicId } from "../../../constants";
import { ClaimContext, ClaimContextType } from "..";
import { calculateAge } from "../../../utilis/methods/dateMethods";
import { getPatientGroupingDisplay } from "../../../utilis/methods/patientGrouping";
import { PatientFullDetailsType } from "../../../PatientCare/PatientBooking/v1/types";
import useAuthentication from "@hooks/useAuthentication";
type StatusType = { id: number; verificationStatus: string };
function DetailsComponent({ data }: { data: PatientFullDetailsType | null }) {
  const { showSnackbar, CustomModal } = usePopup();
  const { setRefetch } = useContext(ClaimContext) as ClaimContextType;
  const {user} = useAuthentication();
  const [claimDownloadType, setClaimDownloadType] = useState<boolean>(true);
  const [openDownloadModal, setOpenDownloadModal] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [verificationParam, setVerificationStatusParams] = useState<any>();
  const { mutate: updateClaimStatus, isLoading: updateLoading } = useMutation(
    UpdateClaimStatus,
    {
      onSuccess: (data) => {
        if (data.responseIndicator == "success") {
          setOpenConfirm(false);
          setVerificationStatusParams(null);
          setRefetch(true);
          showSnackbar({
            message: data.responseMessage,
            variant: "success",
            open: true,
            duration: 2000,
          });
        } else {
          showSnackbar({
            message: data.responseMessage,
            variant: "warning",
            open: true,
            duration: 2000,
          });
        }
      },
    }
  );
  const {
    mutate: getAllStatus,
    data: verificationStatusList,
    isLoading: statusLoading,
  } = useMutation(getallStatus);
  const { mutate: downloadClaim, isLoading: downloadLoading } = useMutation(
    downloadClaims,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          if (result?.response) {
            try {
              const binaryData = atob(result.response.body);
              const byteNumbers = new Uint8Array(binaryData.length);
              for (let i = 0; i < binaryData.length; i++) {
                byteNumbers[i] = binaryData.charCodeAt(i);
              }
              const blob = new Blob([byteNumbers], {
                type: `application/${result.response.fileType || "txt"}`,
              });
              const blobURL = URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = blobURL;
              link.download = `Claim_download_${moment().format("DD-MM-YYYY hh:mm:ss A")}.${result.response.fileType || "txt"}`;
              link.click();
              URL.revokeObjectURL(blobURL);
              showSnackbar({
                message: "Downloaded successfully !",
                variant: "success",
                duration: 2000,
                open: true,
              });
            } catch (error) {
              showSnackbar({
                message: "Failed to download file !",
                variant: "warning",
                duration: 2000,
                open: true,
              });
            }
          } else {
            showSnackbar({
              message: "Error",
              variant: "warning",
              duration: 2000,
              open: true,
            });
          }
        } else {
          showSnackbar({
            message: result.responseMessage,
            variant: "warning",
            duration: 2000,
            open: true,
          });
        }
      },
    }
  );

  const handleDownloadClaim = () => {
    console.log(data);
    downloadClaim({
      claims: [{ encounterId: Number(data?.encounter?.encounterId) }],
      type: "SUBMISSION",
      isProduction: claimDownloadType,
      postOfficeId: Number(data?.postOffice?.postofficeId || 0),
    });
  };

  const handleVerificationStatusChange = () => {
    updateClaimStatus({
      ...verificationParam,
      verificationStatus: verificationParam?.verificationStatus?.id,
    });
  };

  const handleVerificationStatusConfirm = (_: any, option: any) => {
    if (Boolean(option)) {
      setVerificationStatusParams({
        encounterIds: [Number(data?.encounter?.encounterId)],
        verificationStatus: option,
        clinicId,
        createdById:Number(user?.userId),
      });
      setOpenConfirm(true);
    }
  };

  const showAge = (dob: string):string => {
    try{
      const birthDate = calculateAge(dob);
    const keys =
      (birthDate.age == 1 ? `${birthDate.ageType}1` : birthDate.ageType) || "n";
    return `${birthDate.age} ${dateTye[keys as keyof typeof dateTye] || ""}`;
    }catch(e){
       return ""
    }
  };

  useEffect(() => {
    getAllStatus();
  }, []);
//  const regionValue= user?.region;
//    const idHeading =
//   regionValue === "QATAR_REGION"
//     ? "Qatar ID"
//     : "Emirates Id";
const idHeading = "Civil ID";
  return (
    <div className="p-3 flex flex-col gap-5 w-full h-full overflow-y-scroll">
      <CustomModal
        title="Claim Download"
        open={openDownloadModal}
        setOpen={setOpenDownloadModal}
      >
        <div className="p-3 w-[30vw] flex flex-col gap-2">
          <div className="flex gap-2 items-center justify-between">
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                row
                defaultValue={true}
              >
                <FormControlLabel
                  sx={{ fontSize: "10px" }}
                  value={false}
                  control={
                    <Radio
                      // value={claimDownloadType}
                      size="small"
                      onChange={() => {
                        setClaimDownloadType(false);
                      }}
                    />
                  }
                  label="Test"
                />
                <FormControlLabel
                  sx={{ fontSize: "8px" }}
                  value={true}
                  control={
                    <Radio
                      // value={claimDownloadType}
                      size="small"
                      onChange={() => {
                        setClaimDownloadType(true);
                      }}
                    />
                  }
                  label="Production"
                />
              </RadioGroup>
            </FormControl>
            <Button
              disabled={downloadLoading}
              endIcon={
                downloadLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <ArrowDownwardIcon />
                )
              }
              onClick={handleDownloadClaim}
            >
              download
            </Button>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        title="Change status"
        open={openConfirm}
        setOpen={setOpenConfirm}
      >
        <div className="p-3 w-[30vw] flex flex-col gap-2">
          <div className="h-[8vh]">
            Do you want to change the status to &nbsp;
            <strong>
              {verificationParam?.verificationStatus?.verificationStatus}
            </strong>{" "}
            ?
          </div>
          <div className="flex gap-2 items-center justify-end">
            <Button
              variant="text"
              color="error"
              onClick={() => {
                setOpenConfirm(false);
              }}
            >
              no
            </Button>
            <Button
              variant="text"
              color="success"
              endIcon={
                updateLoading && <CircularProgress size={18} color="success" />
              }
              onClick={handleVerificationStatusChange}
            >
              yes
            </Button>
          </div>
        </div>
      </CustomModal>
      <div className="flex justify-between gap-2">
        <Typography variant="h6">Patient details</Typography>
        <div className="w-[20vw] flex">
          {downloadLoading ? (
            <CircularProgress size={18} color="secondary" />
          ) : (
            <Tooltip title="Download claim">
              <IconButton
                color="secondary"
                onClick={() => {
                  setOpenDownloadModal(true);
                }}
              >
                <SimCardDownloadIcon />
              </IconButton>
            </Tooltip>
          )}
          <Autocomplete
            // disabled={updateLoading}
            fullWidth
            loading={statusLoading}
            options={verificationStatusList?.response || []}
            onChange={handleVerificationStatusConfirm}
            getOptionLabel={(option: StatusType) => option?.verificationStatus}
            isOptionEqualToValue={(option: StatusType, value: StatusType) =>
              option?.id === value?.id
            }
            renderInput={(params) => <TextField {...params} label="Status" />}
            getOptionDisabled={(option: StatusType) => option?.id != 1}
          />
        </div>
      </div>
      <div className="flex flex-row gap-5">
        <div>
          <Avatar src={data?.image || ''} sx={{ height: 100, width: 100 }} />
        </div>
        <div className="">
          <Table
            sx={{ minWidth: 650, border: 0 }}
            size="small"
            aria-label="a dense table"
          >
            <TableBody>
              <TableRow key={"row.name" + "index"} sx={{ border: 0 }}>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Name"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.pmaster?.patientName}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  {idHeading}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.pmaster?.emiratesId || data?.pmaster?.gccId || data?.pmaster?.passportNum}
                </TableCell>
              </TableRow>
              <TableRow key={"row.name" + "index"} sx={{ border: 0 }}>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Age"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {showAge(`${data?.pmaster?.dob || ""}`)}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"EMR No/Reg No"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.pmaster?.patientId}
                </TableCell>
              </TableRow>
              <TableRow key={"row.name" + "index"} sx={{ border: 0 }}>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Gender"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.pmaster?.gender}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Mobile No"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : +{data?.amaster?.conCode} {data?.amaster?.mobileNo}
                </TableCell>
              </TableRow>

              <TableRow key={"row.name" + "index"} sx={{ border: 0 }}>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Nationality"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.amaster?.countryName}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Place"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.amaster?.place}
                </TableCell>
              </TableRow>
              <TableRow key={"row.grouping" + "index"} sx={{ border: 0 }}>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Grouping"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }} colSpan={3}>
                  : {getPatientGroupingDisplay(data) || "-"}
                </TableCell>
              </TableRow>
              <TableRow key={"row.name" + "index"} sx={{ border: 0 }}>
                <TableCell width={150} align="left" sx={{ border: 0 }}>
                  {"Insurance Type"}
                </TableCell>
                <TableCell width={300} align="left" sx={{ border: 0 }}>
                  : {data?.insurancePatient?.insurancetype_name}
                </TableCell>
                <TableCell width={140} align="left" sx={{ border: 0 }}>
                  {"Receiver"}
                </TableCell>
                <TableCell width={350} align="left" sx={{ border: 0 }}>
                  : {data?.insurancePatient?.insurance_name}
                </TableCell>
              </TableRow>
              <TableRow key={"row.name" + "index"} sx={{ border: 0 }}>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Payer"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.insurancePatient?.insuranceType == 2 ? data?.insurancePatient.insurance_name : data?.insurancePatient?.inGroup_name}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Insurance plan"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.insurancePatient?.inPlan_name}
                </TableCell>
              </TableRow>
              <TableRow key={"row.name" + "index"} sx={{ border: 0 }}>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Card No"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.insurancePatient?.cardNo}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Policy No"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  : {data?.insurancePatient?.policyNo}
                </TableCell>
              </TableRow>
              <TableRow key={"row.name" + "index"} sx={{ border: 0 }}>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Policy valid from"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  :{" "}
                  {data?.insurancePatient?.policyValidityFrom &&
                  data?.insurancePatient?.policyValidityFrom != "null"
                    ? moment(data?.insurancePatient?.policyValidityFrom).format(
                        "DD-MM-YYYY"
                      )
                    : ""}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  {"Policy valid to"}
                </TableCell>
                <TableCell align="left" sx={{ border: 0 }}>
                  :{" "}
                  {moment(data?.insurancePatient?.policyValidity).format(
                    "DD-MM-YYYY"
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div className="flex justify-end items-end gap-3 w-full ">
          <div className="flex items-center gap-3 w-full"></div>
        </div>
      </div>
    </div>
  );
}

export default DetailsComponent;

const dateTye = {
  D: "Days",
  M: "Months",
  Y: "Years",
  D1: "Day",
  M1: "Month",
  Y1: "Year",
  n: "",
};
